module.exports = __webpack_public_path__ + "static/img/hongshi.75f01fd3.jpg";